import firebase from 'firebase'
import { getConfigByEnv } from '../../shared/firebase/configs.js'

// Get Firebase configuration based on NODE_ENV (from shared configs)
const firebaseConfig = getConfigByEnv()

// Initialize Firebase (Vue 2 app uses Firebase v7 - old SDK)
const firebaseApp = firebase.initializeApp(firebaseConfig)

export default firebaseApp.firestore()
